import { Button, Paper } from "@mui/material";
import { CustomCkeditor } from "components/CustomCkeditor";
import CustomText from "components/typography/CustomText";
import { ERR_NETWORK } from "constants/messages";
import Layout from "layouts";
import { updatePie } from "models/piesModel";
import { useSnackbar } from "notistack";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { openLoading } from "store/reducers/tools";
import FlavourForm from "../forms/FlavourForm";

export default function FlavourDetailComponent() {
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const flavourData = useSelector((state) => state?.app?.flavorData ?? {});
  const [data, setData] = useState({});
  const editFormRef = useRef();

  const handleUpdate = () => {
    const submitData = editFormRef.current?.prepare();
    if (submitData) {
      openLoading(true);
      updatePie({
        data: submitData,
        onFinish: (res, err) => {
          openLoading(false);
          if (res === false) {
            if (!res && err?.message) {
              enqueueSnackbar(err?.message, { variant: "warning" });
            } else {
              enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
            }
            return;
          }
          enqueueSnackbar("Successfully Saved in", { variant: "success" });
          history.push("/flavours");
        },
      });
    }
  };

  useEffect(() => {
    if (!Boolean(flavourData?.id)) return;
    setData(flavourData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flavourData]);
  console.log(data, "Data");
  return (
    <Layout
      breadCrumb={[
        { label: "Flavours", to: "/flavours" },
        { label: "Update Flavour", to: "#" },
      ]}
    >
      <Paper className="p-3">
        <FlavourForm data={data} ref={editFormRef} onChange={setData} />
        <CustomText className="pt-3 pb-2 text-sm" color="light-gray" bold>
          Description
        </CustomText>
        <CustomCkeditor
          value={data?.description ?? ""}
          onChange={(e) =>
            setData((prev) => ({ ...prev, description: e.target.value }))
          }
        />
        <div className="flex items-center justify-end w-full my-4">
          <Button variant="contained" color="secondary" onClick={handleUpdate}>
            Update Flavour
          </Button>
          <Button
            className="mx-2"
            variant="outlined"
            color="secondary"
            onClick={() => history.push("/flavours")}
          >
            CANCEL
          </Button>
        </div>
      </Paper>
    </Layout>
  );
}
